import * as Pedidos from './';
import { Paginacion } from '@ext/index';


export class Coleccion extends Array<Pedidos.Pedido> {


    public Estados: Array<Pedidos.Estados> = [];
    public Tipos: Array<Pedidos.Tipos> = [];
    public Busqueda: string = "";
    public Detalles: string = 'cliente,items,articulo,publicacion,envio,empresa_logistica';
    public Orden: 'DESC' | 'ASC' | string = 'DESC';

    public Pagina: number = 1;
    public Limite: number = 20;



    public Paginacion: Paginacion = new Paginacion();
    public search = async function Search( this: Coleccion, buscarMas: boolean = false ): Promise<'ok' | 'error' | 'vacio'> {

        if ( !buscarMas )
            this.clear();

        let params: any = {};

        if ( this.Busqueda ) {
            params.q = this.Busqueda;
        } else {
            if ( this.Estados.hasRows() ) params.estado = this.Estados.map( x => x.Id ).join( ',' );
            if ( this.Tipos.hasRows() ) params.tipo = this.Tipos.map( x => x.Id ).join( ',' );
        }

        if ( this.Detalles ) params.details = this.Detalles;
        if ( this.Limite ) params.limit = this.Limite;
        if ( this.Pagina ) params.page = this.Pagina;
        if ( this.Orden ) params.sort = this.Orden;

        let c = await Pedidos.Pedido.find( params );
        this.Paginacion = c.Paginacion;
        c.Items.forEach( x => this.push( x ) );

        if ( c.Error ) return 'error';
        else if ( !c.Items.hasRows() ) return 'vacio';

        return 'ok';
    };

}

